module.exports = "<p>\n  button works!\n</p>\n"